/*
  Recherche en plein écran.

  Dès qu'on tape dans la barre de l'en-tête, un panneau s'ouvre sous elle et
  couvre la page avec les vrais résultats, en grille de fiches produit —
  d'après `Downloads\rechercher 2.png` (moulinroty-maboutique.com).

  Comment les résultats arrivent : on demande à Shopify de rendre la section
  `alco-recherche-resultats` dans le contexte de `/search?q=<terme>`, et on
  injecte le morceau de page reçu. C'est l'API de rendu de section, la même
  que pour la page des favoris. Avantage sur la recherche instantanée de
  Dawn : le nombre total de résultats est exact et la grille est complète,
  là où l'API de suggestions plafonne à dix.

  Ce fichier ne fait rien si la barre ouverte n'est pas activée dans
  l'éditeur : il cherche `.alco-recherche` et s'arrête s'il ne la trouve pas.
*/

(function () {
  'use strict';

  var ATTENTE = 350; // ms avant d'interroger le serveur
  var MINI = 2; // nombre de caractères avant de chercher

  var zone = document.querySelector('.alco-recherche');
  if (!zone) return;

  var champ = zone.querySelector('.search__input');
  var panneau = document.querySelector('[data-alco-recherche-panneau]');
  var corps = panneau && panneau.querySelector('[data-alco-recherche-resultats]');
  if (!champ || !panneau || !corps) return;

  // Le panneau est en `position: fixed` : il doit être enfant direct de la
  // page. Laissé dans l'en-tête, il serait rogné dès que l'en-tête collant de
  // Dawn se met à porter une transformation en défilant.
  if (panneau.parentNode !== document.body) document.body.appendChild(panneau);

  var conteneur = panneau;
  var formulaire = zone.querySelector('form');
  var accueil = panneau.querySelector('[data-alco-recherche-accueil]');
  var pastilles = panneau.querySelector('[data-alco-recherche-mots]');

  // Deux vues dans le même panneau : la sélection d'avant-saisie, et les
  // résultats. On n'en montre qu'une à la fois.
  function montrer(vue) {
    if (accueil) accueil.hidden = vue !== 'accueil';
    corps.hidden = vue !== 'resultats';
  }

  var minuteur = null;
  var dernierTerme = '';
  var requeteEnCours = null;

  // On se cale sous la BARRE DE RECHERCHE, pas sous tout l'en-tête : la ligne
  // du menu est masquée mais garde sa place, et attendre sa fin laissait un
  // grand vide entre le logo et les résultats. Le panneau recouvre donc cette
  // bande vide — le menu étant invisible, rien ne s'en trouve caché.
  var ECART = 16; // px de respiration sous le champ

  var CROIX = 40; // hauteur du bouton de fermeture, en px

  // Colonne de référence : elle a la même géométrie que la grille de résultats
  // et que la ligne du tri (mêmes `max-width` et mêmes marges). On s'en sert
  // pour aligner la croix sur leur bord droit.
  var colonne = panneau.querySelector('.rechpl__corps--mots');

  function calerSousEntete() {
    var r = zone.getBoundingClientRect();
    conteneur.style.setProperty('--rechpl-haut', Math.max(0, Math.round(r.bottom)) + ECART + 'px');

    // La croix se centre verticalement sur le champ, pour se poser sur sa
    // ligne — à la place des icônes, masquées pendant la recherche.
    var milieu = r.top + r.height / 2 - CROIX / 2;
    conteneur.style.setProperty('--rechpl-croix', Math.max(0, Math.round(milieu)) + 'px');

    // Et horizontalement sur le bord droit du CONTENU de la colonne, pas sur
    // celui de la fenêtre ni sur le bord extérieur de la colonne.
    //
    // Deux corrections apprises à l'usage :
    //   — `getBoundingClientRect().right` donne le bord de la BOÎTE, marge
    //     intérieure comprise. La colonne en a 5 rem à droite : sans les
    //     déduire, la croix tombait 50 px trop loin ;
    //   — `window.innerWidth` compte la barre de défilement, alors que les
    //     coordonnées de `getBoundingClientRect` ne la comptent pas. On prend
    //     donc `documentElement.clientWidth`, qui les ignore comme elles.
    if (colonne) {
      var rc = colonne.getBoundingClientRect();
      var marge = parseFloat(window.getComputedStyle(colonne).paddingRight) || 0;
      var largeur = document.documentElement.clientWidth;
      var droite = Math.max(0, Math.round(largeur - (rc.right - marge)));
      conteneur.style.setProperty('--rechpl-droite', droite + 'px');
    }
  }

  function ouvrir() {
    if (panneau.hasAttribute('hidden')) {
      panneau.removeAttribute('hidden');
      document.body.classList.add('alco-recherche-ouverte');
    }
    // La mesure vient APRÈS la classe : celle-ci replie la ligne du menu, donc
    // l'en-tête rétrécit. Mesurer avant laisserait une bande vide au-dessus du
    // panneau. `getBoundingClientRect` force le recalcul, la valeur est juste.
    calerSousEntete();
  }

  window.addEventListener('resize', function () {
    if (!panneau.hasAttribute('hidden')) calerSousEntete();
  });

  function fermer() {
    panneau.setAttribute('hidden', '');
    document.body.classList.remove('alco-recherche-ouverte');
  }

  var tri = ''; // vide = tri par pertinence, celui de Shopify par défaut

  /*
    Suggestions de mots — la rangée de pastilles sous le champ.

    POURQUOI CE N'EST PAS SEULEMENT L'API DE SHOPIFY. `/search/suggest.json`
    sait renvoyer des `queries`, des mots tout prêts. Mais cette liste est bâtie
    sur l'HISTORIQUE DES RECHERCHES des visiteurs : la boutique n'ayant jamais
    été ouverte, elle est vide, et le restera longtemps après l'ouverture.
    Vérifié le 2026-08-18 sur « tiss », « doudou », « ours », « bavo » — zéro
    suggestion à chaque fois.

    On demande donc AUSSI les produits, et on tire les mots de leurs titres.
    « tiss » ramène « Coupon de tissu - … » d'où sort *tissu* ; « bavo » ramène
    les bavoirs, « memo » les mémorys. Les mots viennent du catalogue réel : si
    la boutique ne vend pas de peluches, taper « pel » ne propose rien, et c'est
    la bonne réponse.

    Le jour où de vraies recherches existeront, les `queries` de Shopify
    reprendront la main — elles sont testées en premier.
  */

  // Comparaison sans accents ni majuscules : « memo » doit trouver « Mémory ».
  // La décomposition NFD sépare la lettre de son accent, qu'on retire ensuite ;
  // le nombre de caractères est conservé, ce qui permet plus bas de découper la
  // partie déjà tapée par simple longueur.
  function aplatir(texte) {
    return String(texte)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function echapper(texte) {
    return String(texte)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Découpe les titres en mots et ne garde que ceux qui prolongent la saisie.
  // Un mot égal à ce qui est déjà tapé n'apprend rien : il est écarté.
  function motsDesTitres(titres, terme) {
    var cible = aplatir(terme);
    var comptes = {};
    var formes = {};

    titres.forEach(function (titre) {
      String(titre)
        .split(/[^0-9A-Za-zÀ-ÖØ-öø-ÿ]+/)
        .forEach(function (mot) {
          if (mot.length <= terme.length) return;
          var plat = aplatir(mot);
          if (plat.indexOf(cible) !== 0) return;
          comptes[plat] = (comptes[plat] || 0) + 1;
          if (!formes[plat]) formes[plat] = mot.toLowerCase();
        });
    });

    // Les plus fréquents d'abord : ce sont les mots qui décrivent le mieux ce
    // que la boutique vend, pas ceux d'un titre isolé.
    return Object.keys(comptes)
      .sort(function (a, b) {
        if (comptes[b] !== comptes[a]) return comptes[b] - comptes[a];
        return a.localeCompare(b);
      })
      .slice(0, 6)
      .map(function (plat) {
        return formes[plat];
      });
  }

  function afficherPastilles(mots, terme) {
    if (mots.length === 0) {
      pastilles.hidden = true;
      pastilles.innerHTML = '';
      return;
    }

    pastilles.innerHTML = mots
      .map(function (mot) {
        // La partie déjà tapée est mise en valeur, le reste est la suggestion.
        var debut = echapper(mot.slice(0, terme.length));
        var suite = echapper(mot.slice(terme.length));
        return (
          '<li><button type="button" class="rechpl__pastille" data-alco-recherche-mot="' +
          echapper(mot) +
          '"><mark>' +
          debut +
          '</mark>' +
          suite +
          '</button></li>'
        );
      })
      .join('');
    pastilles.hidden = false;
  }

  function proposerMots(terme) {
    if (!pastilles) return;

    var url =
      window.Shopify.routes.root +
      'search/suggest.json?q=' +
      encodeURIComponent(terme) +
      '&resources[type]=query,product&resources[limit]=10';

    fetch(url)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        var resultats = (data && data.resources && data.resources.results) || {};

        // ① Les vraies suggestions de Shopify, si elles existent un jour.
        // `styled_text` est déjà échappé par Shopify, à la balise <mark> près :
        // on retire par précaution toute AUTRE balise et on garde le reste.
        var requetes = resultats.queries;
        if (requetes && requetes.length > 0) {
          pastilles.innerHTML = requetes
            .map(function (q) {
              var brut = String(q.text || '');
              var orne = String(q.styled_text || brut).replace(/<(?!\/?mark\b)[^>]*>/gi, '');
              return (
                '<li><button type="button" class="rechpl__pastille" data-alco-recherche-mot="' +
                echapper(brut) +
                '">' +
                orne +
                '</button></li>'
              );
            })
            .join('');
          pastilles.hidden = false;
          return;
        }

        // ② À défaut, les mots du catalogue.
        var produits = resultats.products || [];
        var titres = produits.map(function (p) {
          return p.title || '';
        });
        afficherPastilles(motsDesTitres(titres, terme), terme);
      })
      .catch(function () {
        pastilles.hidden = true;
      });
  }

  function chercher(terme) {
    // Une frappe rapide lance plusieurs requêtes ; sans cette annulation, une
    // réponse lente arrivée après une plus récente écraserait la bonne.
    if (requeteEnCours) requeteEnCours.abort();
    requeteEnCours = new AbortController();

    panneau.setAttribute('aria-busy', 'true');

    // `type=product` : le panneau ne montre QUE des produits (choix du
    // 2026-08-18). Sans ce paramètre, Shopify renvoie aussi les pages et les
    // articles, et le comptage les inclut — ce qui fausse « 72 résultats ».
    var url =
      window.Shopify.routes.root +
      'search?q=' +
      encodeURIComponent(terme) +
      '&type=product' +
      '&section_id=alco-recherche-resultats';

    if (tri) url += '&sort_by=' + encodeURIComponent(tri);

    fetch(url, { signal: requeteEnCours.signal })
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        if (html === null) return;
        // La réponse est enveloppée dans un <div id="shopify-section-…"> :
        // on ne garde que ce qu'il y a dedans.
        var boite = document.createElement('div');
        boite.innerHTML = html;
        var section = boite.querySelector('.rechpl__corps');
        corps.innerHTML = section ? section.outerHTML : '';
        panneau.removeAttribute('aria-busy');
        montrer('resultats');
        ouvrir();
      })
      .catch(function (e) {
        if (e.name !== 'AbortError') panneau.removeAttribute('aria-busy');
      });
  }

  champ.addEventListener('input', function () {
    var terme = champ.value.trim();

    clearTimeout(minuteur);

    // Champ vidé : on ne ferme pas, on revient à la sélection d'avant-saisie —
    // le panneau reste ouvert tant qu'on est dans le champ.
    if (terme.length < MINI) {
      dernierTerme = '';
      if (pastilles) {
        pastilles.hidden = true;
        pastilles.innerHTML = '';
      }
      if (accueil) {
        montrer('accueil');
        ouvrir();
      } else {
        fermer();
      }
      return;
    }
    if (terme === dernierTerme) return;

    minuteur = setTimeout(function () {
      dernierTerme = terme;
      proposerMots(terme);
      chercher(terme);
    }, ATTENTE);
  });

  // Au clic dans le champ, avant toute saisie : on ouvre sur la sélection —
  // recherches proposées et coups de cœur (maquette `Downloads\doudou.png`).
  // Si du texte est déjà là, on remontre les résultats.
  champ.addEventListener('focus', function () {
    var terme = champ.value.trim();
    if (terme.length >= MINI && corps.innerHTML !== '') {
      montrer('resultats');
      ouvrir();
    } else if (accueil) {
      montrer('accueil');
      ouvrir();
    }
  });

  // Un mot proposé remplit le champ et lance la recherche.
  panneau.addEventListener('click', function (e) {
    var mot = e.target.closest('[data-alco-recherche-mot]');
    if (!mot) return;
    champ.value = mot.getAttribute('data-alco-recherche-mot');
    champ.focus();
    dernierTerme = champ.value;
    chercher(dernierTerme);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fermer();
  });

  // `closest` et non `hasAttribute` : le bouton de fermeture contient une
  // icône, donc un clic dessus a pour cible le `<svg>` ou son `<path>`, jamais
  // le bouton. C'est ce qui rendait la croix inopérante.
  panneau.addEventListener('click', function (e) {
    if (e.target.closest('[data-alco-recherche-fermer]')) fermer();
  });

  // La croix du champ (bouton `reset` de Dawn) vide la saisie : le panneau
  // doit se refermer avec elle, sinon il resterait ouvert sur des résultats
  // qui ne correspondent plus à rien.
  if (formulaire) {
    formulaire.addEventListener('reset', function () {
      clearTimeout(minuteur);
      dernierTerme = '';
      fermer();
      if (accueil) montrer('accueil');
    });
  }

  // Le menu de tri est recréé à chaque réponse : on écoute sur le panneau,
  // pas sur le menu lui-même, qui n'existe pas encore au chargement.
  panneau.addEventListener('change', function (e) {
    if (!e.target.hasAttribute('data-alco-recherche-tri')) return;
    tri = e.target.value;
    if (dernierTerme) chercher(dernierTerme);
  });

  // Un clic hors de la barre et hors du panneau referme.
  document.addEventListener('click', function (e) {
    if (panneau.hasAttribute('hidden')) return;
    if (zone.contains(e.target) || panneau.contains(e.target)) return;
    fermer();
  });
})();
